<template>
    <div>
        <!-- lisitng-detail-sold -->
        <div
            class="listing-detail-sold-price classic"
            v-if="info.listingStatus == 'Sold'"
        >
            <div class="price-container">
                <no-disclosure
                    v-if="!!info.nodisclosureDes || hidePrice"
                    :des="
                        hidePrice
                            ? $t('md-detail-info.nondisclosure')
                            : info.nodisclosureDes
                    "
                />
                <div
                    class="price-value"
                    v-else-if="info.listingStatus != 'Sold'"
                >
                    {{ $ft.formatCurrency({ value: info.price, noSpace:true, currencySymbol }) }}
                </div>
                <div v-else class="sold-price">
                    {{
                        $ft.formatCurrency({
                            value: houseShowSoldPrice ? info.soldPrice : info.price,
                            noSpace: true,
                            currencySymbol
                        })
                    }}
                </div>
                <div
                    class="origin-price"
                    v-if="
                        info.listingStatus == 'Sold' &&
                            showListingPrice &&
                            houseShowSoldPrice &&
                            info.nodisclosureDes == null
                    "
                >
                    <span class="deprecated">{{
                        $ft.formatCurrency({ value: info.price, noSpace: true, currencySymbol})
                    }}</span>
                    <span
                        v-if="
                            info.price &&
                                info.soldPrice != info.price &&
                                trend !== '0.0%'
                        "
                        class="trend"
                        :class="{
                            up: info.soldPrice > info.price,
                            down: info.soldPrice < info.price
                        }"
                    >
                        <span class="iconfont icon-trend-up"></span>
                        <span class="iconfont icon-trend-down"></span>
                        {{ trend }}
                    </span>
                </div>
            </div>
        </div>

        <!-- listing-detail-active -->
        <div class="listing-detail-active classic" v-else>
            <no-disclosure
                v-if="!!info.nodisclosureDes || hidePrice"
                :des="
                    hidePrice
                        ? $t('md-detail-info.nondisclosure')
                        : info.nodisclosureDes
                "
            />
            <span class="price-value" v-else>
                {{ $ft.formatCurrency({ value:info.price, noSpace:true, currencySymbol }) }}
            </span>
        </div>
    </div>
</template>

<script>
import price from "../../price.js"

export default {
    mixins: [price]
};
</script>
<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';
.listing-detail-sold-price.classic {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    .price-container {
        position: relative;
        .sold-price {
            font-size: 36px;
            color: #a8a8a8;
            font-family: var(--font-medium);
            display: inline-block;
            &.mark {
                line-height: 20px;
            }
            @media (max-width: 600px) {
                display: block;
            }
        }
        .nodisclosure {
            .dollar {
                @include color-theme();
                font-size: 24px;
            }
            .secret {
                font-size: 12px;
                @include color-theme();
            }
            .des {
                font-size: 12px;
                color: #ff5661;
            }
        }
        .price-value {
            @include color-theme();
            font-size: 30px;
            font-family: var(--font-bold);
        }
        .origin-price {
            font-size: 16px;
            color: #a8a8a8;
            line-height: 16px;
            margin-top: 10px;
            display: inline-block;
            .deprecated {
                text-decoration: line-through;
                margin: 0 10px;
            }
            .trend {
                font-size: 14px;
                font-family: var(--font-bold);
                display: inline-flex;
                align-items: center;
                &:before {
                    margin-right: 4px;
                    font-size: 14px;
                }
                .icon-trend-up,
                .icon-trend-down {
                    display: none;
                    font-size: 12px;
                    margin-right: 4px;
                }
                &.up {
                    color: #96efb4;
                    .icon-trend-up {
                        display: inline;
                    }
                }
                &.down {
                    color: #ffb8b4;
                    .icon-trend-down {
                        display: inline;
                    }
                }
            }
            @media (max-width: 600px) {
                display: block;
                .deprecated {
                    margin-left: 0;
                }
            }
        }
    }
}
.listing-detail-active.classic {
    .price-value {
        font-size: 36px;
        color: var(--color-text);
        margin-right: 15px;
        font-family: var(--font-bold);
    }
    @media (max-width: 600px) {
        .price-value {
            font-size: 32px;
        }
    }
}
</style>
